import { Component } from '@angular/core';

@Component({
  selector: 'app-support-box',
  templateUrl: './support-box.component.html',
  styleUrls: ['./support-box.component.scss']
})
export class SupportBoxComponent {

  constructor() {
  }


}
